const firebaseConfig = {
  apiKey: "AIzaSyAErHchNz1n20OFskJpJDEjQLFSTAQerkI",
  authDomain: "call-rider.firebaseapp.com",
  projectId: "call-rider",
  storageBucket: "call-rider.appspot.com",
  messagingSenderId: "425619313199",
  appId: "1:425619313199:web:5bb08bfc2080bf959dacda"
};

export default firebaseConfig;